<template>
  <div class="main">

    <tk-header-view class="header" :id="tkid"></tk-header-view>

    <v-container fill-height fluid grid-list-md>
      <v-layout row wrap class="hidden-xs-only">
        <v-flex xs12>
          <v-layout row wrap v-for="(stories, index) in storiesinfo.stories" :key="index">

            <!-- Set card to left -->
            <v-layout wrap justify-start v-if="index % 2 === 0">
              <v-flex xs12 sm8>
                <v-card color="light-blue lighten-2 card-frame" hover elevation-24>
                  <v-card-text class="stories black--text" v-html="stories.story"></v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 v-if="stories.image === ''">
                <v-card color="blue-grey lighten-4 card-frame" hover elevation-24>
                  <v-card-text class="stories black--text" v-html="stories.fact"></v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 v-else>
                <v-card color="blue lighten-2 mb-2 card-frame" class="black--text" hover elevation-24>
                  <v-layout>
                    <v-flex class="ma-2">
                      <v-img class="card-frame" :src="require(`@/img/${stories.image}`)"></v-img>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- Set card to right  -->
            <v-layout row wrap justify-end v-else>
              <v-flex xs12 sm4 v-if="stories.image === ''">
                <v-card color="blue-grey lighten-4 card-frame" hover elevation-24>
                  <v-card-text class="stories black--text" v-html="stories.fact"></v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 v-else>
                <v-card color="blue lighten-2 mb-2 card-frame" class="black--text" hover elevation-24>
                  <v-layout>
                    <v-flex class="ma-2">
                      <v-img class="card-frame" :src="require(`@/img/${stories.image}`)"></v-img>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 sm8>
                <v-card color="light-blue lighten-2 card-frame" hover elevation-24>
                  <v-card-text class="stories black--text" v-html="stories.story"></v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="hidden-sm-and-up">
        <v-flex xs12>
          <v-layout row wrap v-for="(stories, index) in storiesinfo.stories" :key="index">
            <v-flex xs12 sm8>
                <v-card color="light-blue lighten-2 card-frame" hover elevation-24>
                  <v-card-text class="stories black--text" v-html="stories.story"></v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 v-if="stories.image === ''">
                <v-card color="blue-grey lighten-4 card-frame" hover elevation-24>
                  <v-card-text class="stories black--text" v-html="stories.fact"></v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 v-else>
                <v-card color="blue lighten-2 mb-2 card-frame" class="black--text" hover elevation-24>
                  <v-layout>
                    <v-flex class="ma-2">
                      <v-img class="card-frame":src="require(`@/img/${stories.image}`)"></v-img>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Back to top button. Show on mobile/ipad only -->
    <div class="hidden-md-and-up">
      <v-btn
        id="scrolltotop"
        bottom fab fixed right small dark elevation-24
        color="transparent"
        class="back-to-top"
        style="color: blue;"
        slot="activator"
        v-on:click="scrollToTop"
      ><v-icon medium>keyboard_arrow_up</v-icon>
      </v-btn>
    </div>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import TkHeaderView from "./TkHeaderView";
import FooterView from "./FooterView";

export default {
  components: {
    TkHeaderView,
    FooterView
  },
  props: {
    tkid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    show: true,
    title: "",
    lorem: `Lorem`,
  }),
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("scrolltotop").style.display = "block";
      } else {
        document.getElementById("scrolltotop").style.display = "none";
      }
      this.scrolled = window.scrollY > 0;
    }
  },
  computed: {
    ...mapGetters([
      'getById'
    ]),
    storiesinfo() {
     return this.getById(this.tkid)
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.main {
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x1190.jpg"); */
  /* background-image: url("../img/background_with_cat_faces_1024x800.jpg"); */
  /* background-image: url("../img/background_with_colored_cat_paws_800x773.jpg"); */
  /* background-image: url("../img/background_with_colored_cat_paws2nd_2080x960.jpg"); */
  background-image: url("../img/background_colored_paws_1200_983.jpg");
  background-color: #f8f8ff;
  background-repeat: no-repeat;
  background-size: cover;
  max-width: '100%';
  height: '100%';
}
.card-frame {
  border-radius: 4px;
  /* box-shadow: 0 0 2px rgba(0, 0, 0, 1); */
}
.stories {
  /* max-width: '100%'; */
  /* height: 'auto'; */
  margin: 15px;
  padding-right: 50px;
  font-size: 1.1rem;
  line-height: 1.6;
  font-family: Arial, Helvetica, sans-serif;
}
.stories::first-letter {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2rem;
  line-height: 0;
  font-weight: bolder;
  color: blue;
  margin-right: 3px;
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
}
.back-to-top {
  color: rgba(0, 0, 255, 1);
}
.footer {
  margin-top: 20px;
}
/* iPhone 6, 7, 8 ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .main {
    background-image: none;
  }
  .footer {
    margin-top: 60px;
  }
}
/* iPhone 6+, 7+, 8+ ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .main {
    background-image: none;
  }
  .footer {
    margin-top: 60px;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .main {
    background-image: none;
  }
  .footer {
    margin-top: 60px;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .main {
    background-image: none;
  }
  .footer {
    margin-top: 60px;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .main {
    background-image: none;
  }
  .footer {
    margin-top: 60px;
  }
}
/* Samsung Galaxy S3 ----------- */
@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .main {
    background-image: none;
  }
  .footer {
    margin-top: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TkStoriesView.vue